import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f5530d66")

_pushScopeId("data-v-f5530d66")
const _hoisted_1 = { class: "title bgblue subpadding" }
const _hoisted_2 = { class: "t" }
const _hoisted_3 = {
  key: 0,
  class: ""
}
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "codetxt" }, [
  /*#__PURE__*/_createVNode("div", { class: "name" }, "评估指标汇总表")
], -1)
const _hoisted_6 = { class: "tb" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"itme\" data-v-f5530d66><div data-v-f5530d66>检测指标</div><div data-v-f5530d66><div data-v-f5530d66>检测结果</div><div class=\"result-num-box result-num-name\" data-v-f5530d66><div class=\"scorebox\" data-v-f5530d66><div class=\"score-item\" data-v-f5530d66><div data-v-f5530d66>最低值</div></div><div class=\"score-item\" data-v-f5530d66><div data-v-f5530d66>最高值</div></div><div class=\"score-item\" data-v-f5530d66><div data-v-f5530d66>平均值</div></div></div></div></div><div data-v-f5530d66>提示</div><div data-v-f5530d66>参考范围</div></div>", 1)
const _hoisted_8 = { class: "item-pot" }
const _hoisted_9 = { class: "scorebox num" }
const _hoisted_10 = { class: "score-item" }
const _hoisted_11 = { class: "score-item" }
const _hoisted_12 = { class: "score-item" }
const _hoisted_13 = {
  key: 0,
  class: "item-pot"
}
const _hoisted_14 = {
  key: 1,
  class: "item-pot"
}
const _hoisted_15 = {
  key: 0,
  class: "item-pot range"
}
const _hoisted_16 = {
  key: 1,
  class: "item-pot range"
}
const _hoisted_17 = {
  key: 2,
  class: "item-pot range"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "codetxt" }, [
  /*#__PURE__*/_createVNode("div", { class: "name" }, "评估结果汇总表")
], -1)
const _hoisted_19 = { class: "tb" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "itme" }, [
  /*#__PURE__*/_createVNode("div", null, "评估结果"),
  /*#__PURE__*/_createVNode("div", null, "出现频次"),
  /*#__PURE__*/_createVNode("div", null, "占比")
], -1)
const _hoisted_21 = { class: "item-pot" }
const _hoisted_22 = { class: "item-pot" }
const _hoisted_23 = { class: "item-pot range" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "codetxt" }, [
  /*#__PURE__*/_createVNode("div", { class: "name" }, "评估分值趋势图")
], -1)
const _hoisted_25 = { class: "reminder" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.showList, (itemShow) => {
    return (_openBlock(), _createBlock("div", {
      class: "card",
      key: itemShow.name
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(itemShow.name), 1)
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemShow.val, (itemVal) => {
        return (_openBlock(), _createBlock("div", {
          class: "",
          key: itemVal
        }, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "",
              key: item.id
            }, [
              (itemVal == item.name)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, _toDisplayString((item.name == "体重指数" ? "运化功能" : item.name) + "测评"), 1),
                    _hoisted_5,
                    _createVNode("div", _hoisted_6, [
                      _hoisted_7,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.codeList, (code, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "itme result-num-box result-val-box",
                          key: index
                        }, [
                          _createVNode("div", _hoisted_8, _toDisplayString(code.name.replace("体重指数", "运化功能")), 1),
                          _createVNode("div", _hoisted_9, [
                            _createVNode("div", _hoisted_10, [
                              _createVNode("div", null, _toDisplayString(code.minValue), 1)
                            ]),
                            _createVNode("div", _hoisted_11, [
                              _createVNode("div", null, _toDisplayString(code.maxValue), 1)
                            ]),
                            _createVNode("div", _hoisted_12, [
                              _createVNode("div", null, _toDisplayString(code.avgValue), 1)
                            ])
                          ]),
                          _createVNode("div", null, [
                            (code.result === 1)
                              ? (_openBlock(), _createBlock("div", _hoisted_13, "↑"))
                              : _createCommentVNode("", true),
                            (code.result === -1)
                              ? (_openBlock(), _createBlock("div", _hoisted_14, "↓"))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", null, [
                            (!code.maxRange)
                              ? (_openBlock(), _createBlock("div", _hoisted_15, " ≥" + _toDisplayString(code.minRange), 1))
                              : (!code.minRange)
                                ? (_openBlock(), _createBlock("div", _hoisted_16, " ≤" + _toDisplayString(code.maxRange), 1))
                                : (_openBlock(), _createBlock("div", _hoisted_17, _toDisplayString(code.minRange) + "~" + _toDisplayString(code.maxRange), 1))
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_18,
                    _createVNode("div", _hoisted_19, [
                      _hoisted_20,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.resultList, (code, index) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "itme",
                          key: index
                        }, [
                          _createVNode("div", _hoisted_21, _toDisplayString(code.name), 1),
                          _createVNode("div", _hoisted_22, _toDisplayString(code.count) + "次", 1),
                          _createVNode("div", _hoisted_23, _toDisplayString(code.percentage), 1)
                        ]))
                      }), 128))
                    ]),
                    _hoisted_24,
                    _createVNode("div", {
                      class: "ecarts-box echart-pie-box",
                      id: 'echart-pie-box' + item.name + _ctx.dayLength
                    }, null, 8, ["id"]),
                    _createVNode("div", _hoisted_25, " 温馨提示：" + _toDisplayString(item.msg.replace("体重指数", "运化功能")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      }), 128))
    ]))
  }), 128))
})